import { Popper, PopperProps } from '@lyearn/ui';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';

export const getSelectPopperComponent = (width: number) => (props: PopperProps) => {
  return <Popper {...props} placement="bottom-start" style={{ width }} />;
};

export const defaultGetOptionLabel = getSelectOptionLabel;
